import { render, staticRenderFns } from "./PatientsFormAuthPopup.vue?vue&type=template&id=4cb37e86&"
import script from "./PatientsFormAuthPopup.vue?vue&type=script&lang=js&"
export * from "./PatientsFormAuthPopup.vue?vue&type=script&lang=js&"
import style0 from "./PatientsFormAuthPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports